import { z } from 'zod';
import { cidrRequiredSchema } from '#schemas/general/cidr.ts';

export const routableCIDRFormSchema = z.object({
  cidr: cidrRequiredSchema,
  install: z.boolean(),
});

export type RoutableCIDRFormData = z.infer<typeof routableCIDRFormSchema>;
